import { render, staticRenderFns } from "./HostelList.vue?vue&type=template&id=45b8320a"
import script from "../../controllers/hostel/hostel-list.js?vue&type=script&lang=js&external"
export * from "../../controllers/hostel/hostel-list.js?vue&type=script&lang=js&external"
import style0 from "./HostelList.vue?vue&type=style&index=0&id=45b8320a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports